import {
    SET_CARI_FORM_PAGE_DATA,
    SET_ACTIVE_POSITION_DATA,
    SET_ACTIVE_APPLICATION_DATA,
    SET_ACTIVE_VERIFIED_LOGIN_USER_DATA,
    SET_CURRENT_USER_DATA,
    SET_URL_PARAM_DATA,
    RESET_ALL_DATA,
    RESET_ACTIVE_POSITION_DATA,
    RESET_ACTIVE_APPLICATION_DATA,
    RESET_URL_PARAM_DATA,
    OPEN_CARI_MODAL,
    CLOSE_CARI_MODALS,
} from "../constants/actionTypes";

import {
    cloneObject,
    isEmpty
} from "../../functions/generic_functions";

const initialState = {
    activeVerifiedLoginUserData: {},
    activeUserData: {},
    activePositionData: {},
    activeApplicationData: {},
    activeUrlParamData: {},
    cariPage1Data: {},
    cariPage2Data: {},
    cariPage3Data: {},
    cariPage4Data: {},
    cariModalData: {
        errorModal:  {
            visible: false,
            title: "",
            contentData: [],
            contentText: "",
            callBackFuncOnOk: "", //optional
            callBackFuncOnCancel: "", //optional
        },
        submitErrorModal:  {
            visible: false,
            title: "",
            contentData: [],
            contentText: "",
            callBackFuncOnOk: "", //optional
            callBackFuncOnCancel: "", //optional
        },
        submitConfirmationModal: {
            visible: false,
            title: "",
            contentData: [],
            contentText: "",
            callBackFuncOnOk: "", //optional
            callBackFuncOnCancel: "", //optional
        },
        consentContactReferenceModal: {
            visible: false,
            title: "",
            contentData: [],
            contentText: "",
            callBackFuncOnOk: "", //optional
            callBackFuncOnCancel: "", //optional
        },
        addInstitutionModal: {
            visible: false,
            title: "",
            contentData: [],
            contentText: "",
            customInstitutionData: "",
            callBackFuncOnOk: "", //optional
            callBackFuncOnCancel: "", //optional
        },
        addCommentsToDocsUploadedModal: {
            visible: false,
            title: "",
            contentData: [],
            contentText: "",
            callBackFuncOnOk: "", //optional
            callBackFuncOnCancel: "", //optional
            note:"",
        }
    }
};


/*
    NOTE: due to the design of the reducer, there is no history as all values are jsons instead of arrays

    NOTE: ...state => previous state, as redux is async, so it requires the previous state on return parameters: {
        previousState,
        newState
    }
*/
const cariReducer = (state = initialState, action) => {

    var copyCariModalData = cloneObject(state.cariModalData);

    switch (action.type) {

        //Reset the entire redux store data by setting it to intial state
        case RESET_ALL_DATA:
       
            return initialState;
            
            break;

        //Reset the active position data in the redux store
        case RESET_ACTIVE_POSITION_DATA:
            return {
                ...state,
                activePositionData: {}
            };
            break;

        //Reset the active application data in the redux store
        case RESET_ACTIVE_APPLICATION_DATA:
            return {
                ...state,
                activeApplicationData: {}
            };
            break;

        //Reset the active url param data in the redux store
        case RESET_URL_PARAM_DATA:
            return {
                ...state,
                activeUrlParamData: {}
            };
            break;

        //add an entire cari form page data, if single fields are required, return the page's own state with a new variable
        case SET_CARI_FORM_PAGE_DATA:
            switch (action.page_num) {
                case 1:
                    return {
                        ...state,
                        cariPage1Data: action.payload
                    };
                    break;

                case 2:
                    return {
                        ...state,
                        cariPage2Data: action.payload
                    };
                    break;

                case 3:
                    return {
                        ...state,
                        cariPage3Data: action.payload
                    };
                    break;

                case 4:
                    return {
                        ...state,
                        cariPage4Data: action.payload
                    };
                    break;

                default:
            }
            break;

        //set the currently active position data
        case SET_ACTIVE_POSITION_DATA:
            return {
                ...state,
                activePositionData: action.payload
            };
            break;

            
        //set the currently active application data
        case SET_ACTIVE_APPLICATION_DATA:
            return {
                ...state,
                activeApplicationData: action.payload
            };
            break;

        //set active verified login user data such as email and token 
        case SET_ACTIVE_VERIFIED_LOGIN_USER_DATA:
            return {
                ...state,
                activeVerifiedLoginUserData: action.payload
            };
            break;
            
        //set the currently active user data
        case SET_CURRENT_USER_DATA:
            return {
                ...state,
                activeUserData: action.payload
            };
            break;

        //set the currently active url param data
        case SET_URL_PARAM_DATA:
            return {
                ...state,
                activeUrlParamData: action.payload
            };
            break;

        //set the specific cari modal as open
        case OPEN_CARI_MODAL:
            let modalId = action.payload.modalId;

            //set data to modal
            copyCariModalData[modalId] = action.payload;
            copyCariModalData[modalId].visible = true;
            return {
                ...state,
                cariModalData: copyCariModalData
            };
            break;
        
        //set all cari modals as closed
        case CLOSE_CARI_MODALS:

            //loop through all modals and set visibility to false
            for(let modalKey in copyCariModalData) {
                copyCariModalData[modalKey].visible = false;
            }
            return {
                ...state,
                cariModalData: copyCariModalData
            };
            break;
        default:
            return state;
    }
};
export default cariReducer;